import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache
} from '@apollo/client';

import { createErrorLink } from './apolloErrorLink';
import getEnv from './utils/getEnv';

const { REACT_APP_GRAPHQL_URL } = getEnv();

const httpLink = new HttpLink({ uri: REACT_APP_GRAPHQL_URL });

export const APOLLO_CLIENT = new ApolloClient({
  link: ApolloLink.from([createErrorLink(), httpLink]),
  cache: new InMemoryCache()
});
